import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import MaskAnimation from 'components/bolt/maskAnimation/maskAnimation';
import Store from 'store/store';
import 'store/pixels';
import getAppRegions from 'utils/bolt/appRegions';
import { getGeoFromIPAsync } from 'utils/clientUtils';
import LandscapeOverlay from 'components/bolt/landscapeOverlay/landscapeOverlay';
// import s from 'base/bolt/boltApp.sss';
const TIMEOUT = 100;

export default class BoltApp extends BaseComp.default {
	constructor(props) {
		super(props);

		this.onScrollToGift = this.onScrollToGift.bind(this);

		Store.on('SCROLL_TO_GIFT', this.onScrollToGift);

		if (typeof window !== 'undefined') {
			window.addEventListener('visibilitychange', this.onVisibilityChange);
			window.addEventListener('popstate', this.onUrlChange);
		}
	}

	async componentDidMount() {
		// Fix google translate causing node duplication
		const ib = Element.prototype.insertBefore;
		Element.prototype.insertBefore = function(child, ref) {
			if (ref && ref.localName === 'font') {
				child.innerText = ref.innerText;
				return;
			}
			return ib.apply(this, arguments);
		};

		if (window.location.search.match(/noredirect/)) {
			return;
		}
		const { appData } = Store.get();
		const clientGeo = await getGeoFromIPAsync();
		const liveAppRegions = await getAppRegions();
		const appRegion = appData?.meta?.region?.slug;
		let redirectUrl;

		if (clientGeo?.countryCode && (clientGeo.countryCode !== appRegion)) {
			redirectUrl = liveAppRegions[clientGeo.countryCode]?.url;
		}
		if (redirectUrl) {
			window.location.href = redirectUrl;
		}
	}

	componentWillUnmount() {
		super.componentWillUnmout();
		Store.off('SCROLL_TO_GIFT', this.onScrollToGift);
		window.removeEventListener('visibilitychange', this.onVisibilityChange);
		window.removeEventListener('popstate', this.onUrlChange);
	}

	onVisibilityChange() {
		if (document.visibilityState === 'visible') {
			Store.emit('PAGE_SHOW');
		} else {
			Store.emit('PAGE_HIDE');
		}
	}

	onUrlChange() {
		window.location.reload();
	}

	onScrollToGift() {
		Store.emit('GIFT_TRANSITION_STARTED');
		this.slideTimeout = window.setTimeout(() => {
			this.giftTransition.initThree();
		}, TIMEOUT);
	}

	renderLandscapeOverlay() {
		const { fullscreen, client } = Store.get();
		const isMobile = client?.dimensions?.width < 1024;
		const isLandscape = client?.orientation === 'landscape';

		if (isMobile && isLandscape && !fullscreen) {
			return <LandscapeOverlay />;
		}

		return '';
	}

	render(props, state) {
		const baseRender = super.render(props, state);
		const videoRoot = state.appState?.appData?.urls.roots.video;
		const resolution = state.appState?.client?.dimensions?.width < 1024 ? 'mobile' : 'desktop';
		const { activePage } = Store.get();
		if (!Store.get().activePage.startsWith('holding')) {
			const transitionGift = state.appState?.appData?.pages[activePage].data?.transitionGift;

			const video = (
				<MaskAnimation
					ref={ref => this.giftTransition = ref}
					onAnimationEnded={this.onAnimationEnded}
					videoRoot={videoRoot}
					pageId={activePage}
					video={transitionGift}
					resolution={resolution}
					isGiftPage
				/>
			);
			baseRender.children.push(video);
		}
		baseRender.children.push(this.renderLandscapeOverlay());

		return baseRender;
	}
}
